import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'; // must import Router, else switch doesn't work
import Store from '../Store/Store';
import Velocity from 'velocity-animate';
import Header from '../Header/Header';
import DashboardList from '../Dashboard/DashboardList';


const LoginForm = ( props ) => (
  <div id="login-form" style={{ marginTop:'0' }} >
    <div className="products" style={{ textAlign:'left' }}  >
      <h1 style={{ padding:'50px 0 30px 30px', boxSizing:'border-box', marginBottom:'0' }}>Dashboard</h1>
      <div style={{ padding:'0 0 10px 30px' }} >

      <DashboardList/>



      </div>
    </div>
  </div>
)


class Dashboard extends React.Component {

  constructor( props ) {
    super( props );
    this.state = { 
      tmp:null,
    };
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0; 
    document.body.scrollTop = 0; // Safari
  }

  updateInputValue( e, stateObject, type ) {
    let a = this.state[ stateObject ]
    a[ type ] = e.target.value
      this.setState( { [ stateObject ]:a } )
      //console.log( 'this.state.answers', this.state[ stateObject ] )
  }

  render() {
    return ( 
      <Fragment>
        <LoginForm/>
        <Header/>
      </Fragment>
    )
  }
}

export default Dashboard
